import { forwardRef } from 'react';

import { Button } from '..';
import { TProps } from '../types/TProps';

export const ButtonMedium = forwardRef<HTMLButtonElement, TProps>(({ className, ...props }, ref) => (
  <Button ref={ref} className={['btn--md', className].filter(Boolean).join(' ')} {...props} />
));

ButtonMedium.displayName = 'ButtonMedium';
